import { render, staticRenderFns } from "./returnGoodslistNewDialog.vue?vue&type=template&id=31788b80&scoped=true"
import script from "./returnGoodslistNewDialog.vue?vue&type=script&lang=js"
export * from "./returnGoodslistNewDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31788b80",
  null
  
)

export default component.exports